exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer[data-v-57b6a8c4] {\n  background: #8FC31F;\n  color: #FFFFFF;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.footer.phone[data-v-57b6a8c4] {\n    padding: 0.31rem 0;\n    text-align: center;\n    font-size: 0.28rem;\n}\n.footer.pc[data-v-57b6a8c4] {\n    text-align: center;\n    padding: 21.5px calc((100% - 980px) / 2);\n    font-size: 14px;\n}\n", ""]);

// exports
